<main class="bg-black text-white min-h-screen overflow-x-hidden">

  <!-- ===== HERO ===== -->
  <section class="relative min-h-[85vh] flex items-center pt-24 pb-16 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 left-0 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="absolute inset-0 opacity-[0.025]" style="background-image: linear-gradient(rgba(0,170,230,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(0,170,230,0.5) 1px, transparent 1px); background-size: 60px 60px;"></div>
    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="grid md:grid-cols-2 gap-12 items-center">

        <!-- Left: text content -->
        <div>
          <a routerLink="/" class="back-nav" data-aos="fade-down">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient"><polyline points="15 18 9 12 15 6"></polyline></svg>
            Back
          </a>
          <h1 class="hero-col font-black mb-6" data-aos="fade-up" data-aos-delay="100">
            Connected Vehicle <span class="text-varroc-accent">Intelligence</span> for the Enterprise
          </h1>
          <p class="text-varroc-text-gray text-lg leading-relaxed mb-8 max-w-xl" data-aos="fade-up" data-aos-delay="200">
            Power your OEM digital experience, fleet operations, insurance products, and enterprise use cases with Varroc Connect's end-to-end telematics platform.
          </p>
          <div class="flex flex-wrap gap-4 mb-10" data-aos="fade-up" data-aos-delay="300">
            <a routerLink="/contact-us" class="bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all flex items-center gap-2 connected_vehicle_intelligence_book_enterprises_demo_button">
              <i class='bx bx-calendar-check text-xl'></i> Book Enterprise Demo
            </a>
            <a routerLink="/platform" class="border border-varroc-accent/40 font-semibold px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all connected_vehicle_intelligence_explore_platform_button">
              Explore Platform
            </a>
          </div>
          <!-- Stats -->
          <div class="flex flex-wrap gap-6" data-aos="fade-up" data-aos-delay="400">
            <div class="text-left">
              <div class="text-varroc-accent font-black text-2xl">4</div>
              <div class="text-varroc-text-gray text-xs mt-1">Solution Verticals</div>
            </div>
            <div class="text-left">
              <div class="text-varroc-accent font-black text-2xl">500K+</div>
              <div class="text-varroc-text-gray text-xs mt-1">Vehicles Managed</div>
            </div>
            <div class="text-left">
              <div class="text-varroc-accent font-black text-2xl">Enterprise</div>
              <div class="text-varroc-text-gray text-xs mt-1">Grade Security</div>
            </div>
          </div>
        </div>

        <!-- Right: microsite cards grid -->
        <div class="grid grid-cols-2 gap-4" data-aos="fade-left" data-aos-delay="200">
          <a *ngFor="let m of microsites" [routerLink]="m.route" class="feature-card text-left cursor-pointer group block no-underline hover:border-varroc-accent/60 transition-all">
            <i class='bx icon-gradient text-4xl mb-3' [class]="m.icon"></i>
            <div class="text-white font-bold text-sm group-hover:text-varroc-accent transition-colors">{{ m.title }}</div>
            <div class="text-varroc-text-gray text-xs mt-1 leading-tight">{{ m.subtitle }}</div>
            <div class="mt-3 flex items-center justify-start gap-1 text-varroc-accent text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
              Explore <i class='bx bx-right-arrow-alt'></i>
            </div>
          </a>
        </div>

      </div>
    </div>
  </section>

  <!-- ===== STICKY NAV ===== -->
  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id" class="cursor-pointer flex-shrink-0">
          <i class='bx text-base' [class]="s.icon"></i> {{ s.label }}
        </a>
      </div>
    </div>
  </nav>

  <div class="max-w-7xl mx-auto px-6 py-20 space-y-32">

    <!-- ===== AUTOMOTIVE OEM ===== -->
    <section id="automotive" class="section-anchor">
      <div class="grid md:grid-cols-2 gap-12 items-center">
        <div data-aos="fade-right">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Automotive OEM</span>
          <h2 class="text-4xl font-black mt-3 mb-4">Unify Your Entire Vehicle Fleet Old & New</h2>
          <p class="text-varroc-text-gray text-base leading-relaxed mb-6">From legacy internal combustion vehicles to new EVs, deliver a consistent, rich connected experience across your entire installed base without replacing hardware.</p>
          <ul class="space-y-3 mb-8">
            <li *ngFor="let f of [
              'Retrofit OBD + hardware for legacy vehicles',
              'OTA firmware updates across entire fleet',
              'White-label connected car app in weeks',
              'Level 3 digital customer experience',
              'Multi-OEM platform with branded UX'
            ]" class="flex items-center gap-3 text-varroc-text-gray text-sm">
              <i class='bx bx-check-circle icon-gradient text-lg'></i> {{ f }}
            </li>
          </ul>
          <a routerLink="/contact-us" class="inline-block bg-varroc-accent text-white font-bold px-6 py-3 rounded-md hover:bg-varroc-accent-hover transition-all unity_your_entire_vehicle_talk_to_our_team_button">
            Talk to Our Team
          </a>
        </div>
        <div class="grid grid-cols-2 gap-4" data-aos="fade-left">
          <div *ngFor="let stat of [
            {val:'500K+',label:'Vehicles managed'},
            {val:'3x',label:'Faster time to market'},
            {val:'60%',label:'Lower infra cost'},
            {val:'Level 3',label:'Customer experience'}
          ]" class="feature-card text-center">
            <div class="text-3xl font-black text-varroc-accent mb-2">{{ stat.val }}</div>
            <div class="text-white text-sm font-semibold">{{ stat.label }}</div>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- ===== FLEET & LOGISTICS ===== -->
    <section id="fleet" class="section-anchor">
      <div class="grid md:grid-cols-2 gap-12 items-center">
        <div class="order-2 md:order-1 grid grid-cols-3 gap-4" data-aos="fade-right">
          <div *ngFor="let f of [
            {icon:'bx-map-alt', title:'Live Tracking'},
            {icon:'bx-time', title:'ETA Engine'},
            {icon:'bx-badge-check', title:'Compliance'},
            {icon:'bx-gas-pump', title:'Fuel Analytics'},
            {icon:'bx-bell', title:'Alerts'},
            {icon:'bx-bar-chart', title:'Reports'}
          ]" class="feature-card text-center p-4">
            <i class='bx icon-gradient text-2xl mb-2' [class]="f.icon"></i>
            <div class="text-white text-xs font-semibold">{{ f.title }}</div>
          </div>
        </div>
        <div class="order-1 md:order-2" data-aos="fade-left">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Fleet & Logistics</span>
          <h2 class="text-4xl font-black mt-3 mb-4">Command Your Fleet in Real Time</h2>
          <p class="text-varroc-text-gray text-base leading-relaxed mb-6">Full-stack fleet management — from vehicle tracking to driver safety and compliance — all in one platform with open APIs for your existing TMS or ERP.</p>
          <ul class="space-y-3 mb-8">
            <li *ngFor="let f of [
              'Real-time GPS tracking with &lt;2s refresh',
              'AIS-140 compliant tracking & alerts',
              'Driver behaviour scoring and coaching',
              'Automated maintenance scheduling',
              'Custom reports & white-label dashboard'
            ]" class="flex items-center gap-3 text-varroc-text-gray text-sm">
              <i class='bx bx-check-circle icon-gradient text-lg'></i> <span [innerHTML]="f"></span>
            </li>
          </ul>
          <div class="flex flex-wrap gap-3">
            <a routerLink="/contact-us" class="inline-flex items-center gap-2 bg-varroc-accent text-white font-bold px-6 py-3 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all command_your_fleet_get_fleet_demo_button">
              <i class='bx bx-calendar-check'></i> Get Fleet Demo
            </a>
            <a routerLink="/solutions/business/fleet-logistics" class="inline-flex items-center gap-2 border border-varroc-accent/40 font-semibold px-6 py-3 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all command_your_fleet_know_more_button">
              <i class='bx bx-info-circle'></i> Know More
            </a>
            <a href="https://app.fleetiq.io/#/" target="_blank" rel="noopener noreferrer" class="inline-flex items-center gap-2 border border-varroc-border font-semibold px-6 py-3 rounded-md hover:border-varroc-accent/60 hover:bg-varroc-dark transition-all">
              <i class='bx bx-log-in-circle'></i> Login <i class='bx bx-link-external text-xs opacity-60'></i>
            </a>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- ===== INSURANCE / BFSI ===== -->
    <section id="insurance" class="section-anchor">
      <div class="mb-14" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Insurance & BFSI</span>
        <h2 class="text-4xl font-black mt-3 mb-4">Usage-Based & Behaviour-Based Insurance</h2>
        <p class="text-varroc-text-gray text-lg max-w-2xl mr-auto">Build differentiated motor insurance products powered by real driving data — reducing claims, improving underwriting accuracy, and delighting customers.</p>
      </div>
      <div class="grid md:grid-cols-3 gap-6">
        <div *ngFor="let card of [
          {icon:'bx-tachometer', title:'UBI / PAYD', desc:'Usage-Based Insurance with pay-as-you-drive pricing from real mileage and trip data.'},
          {icon:'bx-user-check', title:'Driver Score APIs', desc:'Real-time driver risk scoring via API — integrate into your underwriting engine in hours.'},
          {icon:'bx-file', title:'FNOL Automation', desc:'First Notice of Loss triggered automatically from crash detection events.'},
          {icon:'bx-line-chart', title:'Claims Analytics', desc:'AI-driven crash reconstruction and fraud detection from telemetry replay.'},
          {icon:'bx-gift', title:'Rewards Engine', desc:'Customer engagement through telematics-linked loyalty and rewards programs.'},
          {icon:'bx-shield-x', title:'Fraud Detection', desc:'Identify staged accidents and suspicious claims using contextual driving data.'}
        ]" class="feature-card" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="($index * 80).toString()">
          <i class='bx icon-gradient text-2xl mb-3' [class]="card.icon"></i>
          <h3 class="text-white font-bold mb-2">{{ card.title }}</h3>
          <p class="text-varroc-text-gray text-sm leading-relaxed">{{ card.desc }}</p>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- ===== ENTERPRISE ===== -->
    <section id="enterprise" class="section-anchor">
      <div class="grid md:grid-cols-2 gap-12 items-center">
        <div data-aos="fade-right">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Enterprise</span>
          <h2 class="text-4xl font-black mt-3 mb-4">Mobility Intelligence at Enterprise Scale</h2>
          <p class="text-varroc-text-gray text-base leading-relaxed mb-6">Whether you manage corporate fleets, smart city mobility, or supply chain logistics — Varroc Connect scales to your complexity with enterprise SLAs and dedicated support.</p>
          <div class="grid grid-cols-2 gap-4 mb-8">
            <div *ngFor="let f of [
              {icon:'bx-lock-alt', title:'SSO & SAML', desc:'Enterprise identity integration'},
              {icon:'bx-server', title:'On-Premise Option', desc:'Deploy in your own cloud or DC'},
              {icon:'bx-support', title:'Dedicated CSM', desc:'Named customer success manager'},
              {icon:'bx-data', title:'Custom Data Model', desc:'Tailored schema for your use case'}
            ]" class="bg-varroc-dark border border-varroc-border rounded-xl p-4">
              <i class='bx icon-gradient text-xl mb-2' [class]="f.icon"></i>
              <div class="text-white font-semibold text-sm">{{ f.title }}</div>
              <div class="text-varroc-text-gray text-xs mt-1">{{ f.desc }}</div>
            </div>
          </div>
          <a routerLink="/contact-us" class="inline-block bg-varroc-accent text-white font-bold px-6 py-3 rounded-md hover:bg-varroc-accent-hover transition-all mobility_intelligence_contact_enterprise_team_button">
            Contact Enterprise Team
          </a>
        </div>
        <div class="feature-card text-center p-20" data-aos="fade-left">
          <i class='bx bx-buildings icon-gradient text-6xl mb-6'></i>
          <h3 class="text-white font-black text-2xl mb-4">Enterprise Partnership</h3>
          <p class="text-varroc-text-gray text-sm leading-relaxed mb-6">Join leading enterprises using Varroc Connect for mission-critical mobility intelligence.</p>
          <a routerLink="/contact-us" class="inline-block border border-varroc-accent text-varroc-accent font-semibold px-6 py-3 rounded-md hover:bg-varroc-accent hover:text-white transition-all">
            Partner With Us
          </a>
        </div>
      </div>
    </section>

  </div>
</main>
